import Order from 'App/Pages/Operator/Main/Orders/Order'
import orderFragment from 'App/Pages/Operator/Main/Orders/Order/fragment'
import Shift from 'App/Pages/Operator/Main/Shifts/Shift'
import shiftFragment from 'App/Pages/Operator/Main/Shifts/Shift/fragment'
import useTwilioDevice, {useMyCallingCapabilityToken} from 'App/hooks/useTwilioDevice'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import Button from 'orionsoft-parts/lib/components/Button'
import React from 'react'
import CallClient from 'src/App/Pages/Inbox/Conversation/CallClient'
import CallOrder from './CallOrder'
import CallToAnswer from './CallToAnswer'
import Close from './Close'
import ConversationLogs from './ConversationLogs'
import ExportConversation from './ExportConversation'
import FreeDriver from './FreeDriver'
import ImportantInfo from './ImportantInfo'
import PreviousConversations from './PreviousConversations'
import SetPriority from './SetPriority'
import styles from './styles.css'

export default function Information({conversationId, inboxView}) {
  const callingCapabilityToken = useMyCallingCapabilityToken()
  const {currentCallPhoneNumber, makeCall, stopCall} = useTwilioDevice(callingCapabilityToken)
  const {conversation, refetch} = useQuery({
    query: gql`
      query getConversation($conversationId: ID) {
        conversation(conversationId: $conversationId) {
          _id
          closedAt
          priority
          vehicle {
            _id
            code
            categoryId
            phone
            firstName
            liftBanAt
            bannedAt
            activeShift {
              _id
              ...operatorShiftInformation
              activeOrders {
                _id
                points {
                  phone
                }
                ...operatorOrderInformation
              }
            }
            gpsIntegrity {
              status
              statusLabel
              confirmedAlerts
              suspectedAlerts
              mockLocationReports
              sharedAccountAlerts
              lastDetectedAt
              signals
            }
            lastEndedConversations {
              _id
              startedAt
              closedByName
            }
          }
          lastActivityAt
          logs {
            senderName
            text
            date
          }
        }
      }
      ${shiftFragment}
      ${orderFragment}
    `,
    variables: {conversationId},
    pollInterval: 10000,
    partial: true,
  })

  if (!conversation) {
    return (
      <div className={styles.container}>
        <div className={styles.title}>Cargando...</div>
      </div>
    )
  }

  const {vehicle} = conversation
  return (
    <div className={styles.container}>
      {inboxView ? null : (
        <div className={styles.title}>
          Driver #{vehicle.code} {vehicle.firstName}
        </div>
      )}
      <div className={styles.content}>
        <SetPriority conversation={conversation} />

        {inboxView ? null : vehicle.categoryId}
        <ImportantInfo vehicle={conversation.vehicle} />
        <br />
        <div>
          <Button onClick={() => window.open(`/operator/vehicles/${conversation.vehicle._id}`)}>
            Ver perfil completo
          </Button>
        </div>
        <br />
        <Close conversation={conversation} />
        <br />
        <CallToAnswer vehicle={conversation.vehicle} />
      </div>
      <div className='divider' />
      {vehicle.activeShift ? (
        <>
          <div className={styles.smallTitle}>Turno</div>
          <Shift shift={vehicle.activeShift} />
          <div className='divider' />
          <div className={styles.smallTitle}>Pedidos</div>

          {vehicle.activeShift.activeOrders.length ? (
            vehicle.activeShift.activeOrders.map(order => (
              <div className={styles.orderContainer} key={order._id}>
                <Order order={order} refetch={refetch} />
                {inboxView ? (
                  <CallClient
                    order={order}
                    makeCall={makeCall}
                    stopCall={stopCall}
                    currentCallPhoneNumber={currentCallPhoneNumber}
                    phone={order.points[1].phone}
                  />
                ) : (
                  <CallOrder order={order} />
                )}
                <FreeDriver order={order} onSuccess={refetch} />
              </div>
            ))
          ) : (
            <div className={styles.noOrders}>Sin pedidos activos</div>
          )}
        </>
      ) : null}
      <div className={styles.content}>
        <ConversationLogs conversation={conversation} />
      </div>
      {conversation.vehicle && conversation.vehicle.lastEndedConversations ? (
        <PreviousConversations conversations={conversation.vehicle.lastEndedConversations} />
      ) : null}
      <ExportConversation conversationId={conversationId} />
    </div>
  )
}
